import helpers from '../../helpers'
import user from '../../store/modules/user'
import moment from 'moment'
import $format from '../../utils/formatter'
import { availableLotto } from '../../api/balance'

export default {
  'entityName': 'siteresponse_has_drug',
  'title': 'Drugs',
  id: ['siterequest_id', 'drug_id', 'lotto'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'descending': true
  },
  'fields': [
    {
      small: true,
      value: 'drug_id',
      reference: 'siterequest_has_drug',
      id: 'drug_id',
      text: 'Drug',
      type: 'autocomplete',
      title: 'drug.name',
      subtitle: ({ drug }) =>  $format('drug', drug, 'subtitle'), // drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      table: {
        text: 'drug.name'
      },
      render: ({ drug }) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      filter: item => ({ siterequest_id: item.siterequest_id, n_confirmed: '>0' }),
      validators: ['required']
    },
    {
      value: '_always_available',
      deps: ['drug_id'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.drug.always_available
    },
    {
      value: '_packaging',
      deps: ['drug_id'],
      visible: false,
      default: (item, args, selected) => selected && selected.drug.packaging
    },
    {
      value: '_serials_available',
      deps: ['drug_id'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.drug.serials_available
    },    
    {
      value: '_available_pieces',
      deps: ['_lotto'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.n_pieces
    },        
    {
      small: true,
      "value": "_lotto",
      "text": "Batch number",
      id: 'lotto',
      reference: 'balance',
      "type": "autocomplete",
      title: 'lotto',
      subtitle: item => `${item.expiration} (${item.n_pieces})`,
      "table": {
          "sortable": true,
          "filter": true
      },
      deps: ['_packaging'],
      visible: item => !item._always_available && item._packaging !== 'Labels',
      filter: item => {
        return ({ drug_id: item.drug_id, n_pieces: ">0", place: 'STORAGE',  ...(!['Administrator', 'EMN User'].includes(user.state.role))  && { expiration: `>=${moment().add(7, 'days').toISOString()}` } })
      },
      validators: [
        'required'
      ],
      readonly: item => !item.drug_id
  }, 
  {
    value: '_2lotto',
    small: true,
    type: "combobox",
    list: availableLotto,
    title: 'lotto',
    id: 'lotto',
    subtitle: item => item.expiration,
    text: 'Batch number',
    deps: ['_packaging'],
    visible: item => !!item._always_available && item._packaging !== 'Labels',
    validators: [
      'required',
      'nowhitespace'
    ],
  },
  {
    value: 'lotto',
    type: 'hidden',
    deps: ['_2lotto', '_lotto'],
    default: item => item._lotto ? item._lotto : item._2lotto || '',
    validators: ['required']
  },
  {
      "value": "expiration",
      small: true,
      "text": "Expiration",
      "type": "datetime",
      "table": {
          "sortable": true,
          "filter": false
      },
      deps: ['lotto', 'drug_id'],
      min: state => !['Administrator', 'EMN User'].includes(state.user.role) ? moment().add(7, 'days').toISOString() : undefined,
      visible: item => item._packaging !== 'Labels',
      default: (item, args, selected) => selected && selected.expiration,
      readonly: item => !item._always_available,
      'validators': ['required']
  },
  {
    full: true,
    "value": "_original_serials",
    text: 'Available Serials',
    deps: ['lotto', 'drug_id'],
    default: (item, args, selected) => selected && selected.serials,
    visible: item => !!item._original_serials,
    readonly: true
  },
  {
    value: '_n_needed',
    id: 'n_pieces',
    reference: 'siterequest_has_drug',
    small: true,
    title: 'n_pieces',
    text: 'N. requested',
    deps: ['drug_id'],
    default: (item, args, selected) => selected && selected.n_confirmed,
    filter: item => {
      return { drug_id: item.drug_id, siterequest_id: item.siterequest_id }
    },
    readonly: true,
    // type: ['hidden']
  },
  {
    "value": "n_pieces",
    "text": "Quantity",
    "type": "number",
    small: true,
    table: {
      sortable: true
    },
    deps: ['serials'],
    validators: [
      'required',
      'number',
      (field, value, item) => (typeof item._n_needed === 'undefined') || item.n_pieces <= item._n_needed || `N.items has to be <= N.requested (${item._n_needed})`,
      (field, value, item) => !item._available_pieces || item._available_pieces >= value || `Not enough available items (${item._available_pieces})`
    ],
    default: item => {
      return item.serials && helpers.nSerials(item.serials)
    },
    readonly: item => !!item._serials_available || !item.drug_id
  },
  {
      full: true,
      "value": "_serials",
      "text": "Serial numbers",
      "type": "textarea",
      deps: ['lotto', '_serials_available', '_original_serials'],
      visible: item => !!item._original_serials || item._serials_available,
      // default: (item, args, selected) => {
        // restituisce il numero di seriali richiesto
        // return selected && helpers.getFirstSerials(selected.serials, item._n_needed)
      // },
      // readonly: item => !item.lotto,
      "validators": [
          "required",
          "serials",
          (field, value, item) => {
            if (!item._original_serials) return true
            const ret = helpers.subtractSerials(value, item._original_serials)
            const notAvailable = helpers.compatSerials(ret)
            if (ret.length) {
              return `Serials ${notAvailable} not available`
            }
            if (helpers.nSerials(value) > item._n_needed) return `N.items has to be <= N.requested (${item._n_needed})`

            return true
          },
      ]
    },
    {
      value: 'serials',
      type: 'hidden',
      text: 'Serial numbers',
      table: true,
      render: item => (item.serials && ` (${item.serials.replaceAll(',', ', ')})`),
      deps: ['_serials'],
      default: item => {
        return item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
      }
    },
  ],
  actions: ['remove']
}
